import { render, staticRenderFns } from "./PaieskaTvirtinimas.vue?vue&type=template&id=37c8f6ac&scoped=true&"
import script from "./PaieskaTvirtinimas.vue?vue&type=script&lang=js&"
export * from "./PaieskaTvirtinimas.vue?vue&type=script&lang=js&"
import style0 from "./PaieskaTvirtinimas.vue?vue&type=style&index=0&id=37c8f6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c8f6ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VDataTable,VIcon})
